export default __webpack_public_path__ + "static/media/bmi_csv_help.9672ee87.png";